import {Page} from '../../../utils/page';
import {ProductSearchRequest} from '../../../models/quote/product-search-request';
import {ProductsByServicesRequest} from '../../../models/quote/products-by-services-request';
import {CmcProductManagerDatabase} from "../../databases/cmc-product-manager.database";

export class SqliteCmcProductRepository {

    constructor(private readonly cmcProductManagerDatabase: CmcProductManagerDatabase) {}

    async searchArticles(productSearchRequest: ProductSearchRequest, pageable: Map<string, string>): Promise<Page<any>> {
        const page = pageable.has('page') ? parseInt(pageable.get('page')!) : 0;
        const size = pageable.has('size') ? parseInt(pageable.get('size')!) : 20;

        let whereClause =
            ` WHERE type NOT IN ('PACK_CONSUMABLE', 'DEVICE_CONSO')
                    AND serviceCode = '${productSearchRequest.service}'
                    AND cmcProtocolCode = '${productSearchRequest.cmcProtocolCode}' `;

        if (productSearchRequest.searchParam) {
            whereClause += ` AND (codeElis = "${productSearchRequest.searchParam}" OR label LIKE "%${productSearchRequest.searchParam}%") `;
        }

        if (productSearchRequest.elisCodeList) {
            whereClause += ` AND codeElis in (${productSearchRequest.elisCodeList.map(code => `'${code}'`).join(',')})`;
        }

        const pagedDocs = await this.cmcProductManagerDatabase.queryObjects<any>(`
            SELECT *
            FROM product ${whereClause}
            LIMIT ${size} OFFSET ${page * size}
        `,null, ['productConsumables', 'productDetails']);

        const totalDocumentsCount = await this.cmcProductManagerDatabase.count(`SELECT count(*)
                                                              FROM product ${whereClause}`);

        const products: any[] = [];
        for (const product of pagedDocs) {
            product.classification = await this.getClassificationById(product.id.toString());
            for (const productConsumable of product.productConsumables) {
                productConsumable.consumable.classification = await this.getClassificationById(productConsumable.consumable.id.toString());
            }
            products.push(product);
        }
        return {
            totalElements: totalDocumentsCount,
            totalPages: Math.ceil(totalDocumentsCount / size),
            first: page === 0,
            last: (page + 1) * size >= totalDocumentsCount,
            size: size,
            content: products,
            number: page,
            numberOfElements: pagedDocs.length,
            empty: pagedDocs.length === 0
        };
    }

    async findArticlesForDuplication(requestData: ProductsByServicesRequest): Promise<any[]> {
        let mapOfServiceCodeElis = requestData.codesByService;
        if (Object.keys(mapOfServiceCodeElis).length == 0) {
            return [];
        }
        let result: any[] = [];
        for (const [service, productCodes] of Object.entries(mapOfServiceCodeElis)) {
            let productSearchRequest: ProductSearchRequest = new ProductSearchRequest(
                requestData.country,
                requestData.role,
                service,
                null,
                requestData.extinctionArticlesIncluded,
                requestData.type,
                requestData.cmcProtocolCode,
                Array.from(new Set(productCodes))
            );
            let pageable = new Map()
                .set('page', 0)
                .set('size', productCodes.length);
            let articlePages: Page<any> = await this.searchArticles(productSearchRequest, pageable);
            
            result.push({
                service,
                products: articlePages.content
            });
        }
        return result;
    }

    async getClassificationsByGroupingCodes(groupingCodes: string[]): Promise<any[]> {
        return await this.cmcProductManagerDatabase.queryObjects<any>(`
                    SELECT * FROM classification
                    WHERE groupingCode IN (${groupingCodes.map(code => `'${code}'`).join(',')})`
            , null,['productPricings']);
    }

    async getClassificationById(id: string): Promise<any> {
        const classifications =
            await this.cmcProductManagerDatabase.queryObjects<any>(`
                    SELECT * FROM classification
                    WHERE id = '${id}'`, null, ['productPricings']);
        if(classifications.length > 0) {
            return classifications[0];
        }
        return null;
    }

}
